import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import StandardTableVue from '@/components/table/StandardTable.vue';
import { Empty } from 'ant-design-vue';
import { getProductList, getClassify } from '@/services/productDetail.js';
import { getInclude, deleteInclude } from './utils';
import { TreeSelect } from 'ant-design-vue';
import { getGoodsGroupedList, getsrxList } from '@/services/product/goodsGrouped.js';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  components: {
    StandardTableVue: StandardTableVue
  },
  i18n: require("@/pages/productmanager/goodsGrouped/i18n-group.js"),
  props: {
    alreadySelect: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 是否选择完商品后 按照差集来返回  目前返回分两种  一种是全部数据返回 一种是返回差集
    returnXor: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    var h = this.$createElement;
    var columns = [{
      dataIndex: 'productNo',
      title: this.$t('account.goodsNumber')
    }, {
      title: this.$t('account.goodsName'),
      dataIndex: 'productName',
      scopedSlots: {
        customRender: 'goodsName'
      }
    }, {
      title: this.$t('publicuse.status'),
      dataIndex: 'productStatus',
      scopedSlots: {
        customRender: 'productStatus'
      }
    }, {
      title: this.$t('account.srx'),
      dataIndex: 'supplierName'
    }];
    return {
      labelCol: {
        span: 9
      },
      wrapperCol: {
        span: 15
      },
      columns: columns,
      queryLoading: false,
      srxList: [],
      productClassifyList: [],
      productGrounpdList: [],
      queryParam: {
        srx: null,
        productGrounpd: [],
        productClassify: [],
        startProductNo: '',
        endProductNo: '',
        goodsContent: '',
        janparam: ''
      },
      loadingTable: false,
      pagination: {
        pageSizeOptions: ['5', '10', '20'],
        total: 0,
        showTotal: function showTotal(total, r) {
          return "".concat(_this.$t('account.total2')).concat(total);
        },
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        'show-quick-jumper': true
      },
      data: [],
      indeterminate: false,
      checkAll: false,
      selectedRowKeys: [],
      locale: {
        emptyText: h("a-empty", {
          "attrs": {
            "image": Empty.PRESENTED_IMAGE_SIMPLE
          }
        }, [" ", h("span", {
          "slot": "description"
        }, [" ", this.$t('account.emptyGoodsTip'), " "]), "  "])
      },
      total: 0,
      visible: false,
      selectedData: [],
      optionIdList: [],
      btnLoading: false,
      SHOW_PARENT: SHOW_PARENT
    };
  },
  mounted: function mounted() {
    //  this.initData()
  },
  computed: {
    rowSelection: function rowSelection() {
      var _this2 = this;
      return {
        onChange: function onChange(selectedRowKeys, selectedRows) {
          // this.$emit('getTotal', selectedRowKeys.length,selectedRows)
          // console.log(selectedRowKeys,'keys........')
          _this2.selectedRowKeys = selectedRowKeys;
          // this.total = this.selectedRowKeys.length
          // this.indeterminate = !! this.selectedRowKeys.length &&  this.selectedRowKeys.length < this.data.length
          // this.checkAll = this.selectedRowKeys.length === this.data.length
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
        selectedRowKeys: this.selectedRowKeys
      };
    }
  },
  watch: {
    selectedRowKeys: function selectedRowKeys(newVal, oldVal) {
      this.getState(newVal, this.optionIdList);
      this.total = this.selectedRowKeys.length;
    },
    visible: function visible(newVal, oldVal) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var params2, res, params, res2, res3;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!newVal) {
                _context.n = 4;
                break;
              }
              _this3.selectedRowKeys = _this3.alreadySelect;
              // 获取商品分类列表
              params2 = {
                type: 1
              };
              _context.n = 1;
              return getClassify(params2);
            case 1:
              res = _context.v;
              if (res.data.code == 200) {
                _this3.productClassifyList = res.data.data;
              }
              // 获取商品分组列表
              params = {
                scene: 2
              };
              _context.n = 2;
              return getGoodsGroupedList(params);
            case 2:
              res2 = _context.v;
              if (res2.data.code == 200) {
                console.log(res2);
                _this3.productGrounpdList = res2.data.data.list.map(function (item) {
                  return {
                    value: item.groupId,
                    name: item.groupName
                  };
                });
              }
              // 获取仕入先列表
              _context.n = 3;
              return getsrxList();
            case 3:
              res3 = _context.v;
              if (res3.data.code == 200) {
                _this3.srxList = res3.data.data.map(function (item) {
                  return {
                    value: item.supplierCode,
                    name: item.supplierName
                  };
                });
              }
            case 4:
              return _context.a(2);
          }
        }, _callee);
      }))();
    }
  },
  methods: {
    initData: function initData(info, query) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var h, params, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              h = _this4.$createElement;
              console.log(_this4.queryParam, 'select');
              // console.log(this.queryParam.productGrounpd.join(','),'qqqqqqqq')
              _this4.loadingTable = true;
              params = {
                page: query ? 1 : _this4.pagination.current,
                size: _this4.pagination.pageSize,
                needAllOptionIds: true,
                scene: 2,
                condition: {
                  productName: _this4.queryParam.goodsContent,
                  startProductNo: _this4.queryParam.startProductNo,
                  endProductNo: _this4.queryParam.endProductNo,
                  productClassify: _this4.queryParam.productClassify,
                  productGroupIdStr: _this4.queryParam.productGrounpd.length > 0 ? _this4.queryParam.productGrounpd.join(',') : '',
                  supplierCode: _this4.queryParam.srx,
                  productBarcode: _this4.queryParam.janparam
                }
              };
              if (query) {
                _this4.pagination.current = 1;
              }
              _context2.n = 1;
              return getProductList(params);
            case 1:
              res = _context2.v;
              try {
                if (res.data.code == 200) {
                  _this4.data = res.data.data.list;
                  _this4.pagination.total = res.data.data.totalNum;
                  _this4.optionIdList = res.data.data.optionIdList;
                  if (_this4.data.length == 0) {
                    _this4.locale = {
                      emptyText: h("a-empty", {
                        "attrs": {
                          "image": Empty.PRESENTED_IMAGE_SIMPLE
                        }
                      }, [" ", h("span", {
                        "slot": "description"
                      }, [" ", _this4.$t('account.noGoods'), " "]), "  "])
                    };
                  }
                  // 说明点的是全部也全部选 
                  if (info) {
                    console.log(1111);
                    if (getInclude(_this4.selectedRowKeys, _this4.optionIdList) == 3) {
                      _this4.checkAll = false;
                      _this4.indeterminate = false;
                      _this4.selectedRowKeys = deleteInclude(_this4.selectedRowKeys, _this4.optionIdList);
                      console.log(_this4.selectedRowKeys, 'selectRows');
                    } else {
                      _this4.checkAll = true;
                      _this4.indeterminate = false;
                      _this4.selectedRowKeys = Array.from(new Set([].concat(_toConsumableArray(_this4.optionIdList), _toConsumableArray(_this4.selectedRowKeys))));
                      console.log(_this4.selectedRowKeys, 'selectRows22');
                    }
                  } else {
                    _this4.getState(_this4.selectedRowKeys, _this4.optionIdList);
                  }
                  _this4.total = _this4.selectedRowKeys.length;
                }
              } catch (_unused) {} finally {
                _this4.queryLoading = false;
                _this4.loadingTable = false;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getState: function getState(arr1, arr2) {
      // 一开始搜索5个 全部选了 又搜索了10个  应该改为半选
      if (getInclude(arr1, arr2) == 2) {
        this.checkAll = false;
        this.indeterminate = true;
      }
      // 选择了5个 又搜索了没有 应该把全部选置为空
      if (getInclude(arr1, arr2) == 1) {
        this.checkAll = false;
        this.indeterminate = false;
      }
      // 选择了5个 又搜索了包含所有的 应该把全部选置为true
      if (getInclude(arr1, arr2) == 3) {
        this.checkAll = true;
        this.indeterminate = false;
      }
    },
    queryProductList: function queryProductList() {
      // 查询的时候加上按钮的Loading 防止连续点击
      this.queryLoading = true;
      this.initData(false, true);
    },
    changePage: function changePage(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData(false, false);
    },
    showSizeChange: function showSizeChange(e) {
      this.pagination.current = e.current;
      this.pagination.pageSize = e.pageSize;
      this.initData(false, false);
    },
    selectAll: function selectAll() {
      this.initData(true, false);
    },
    getdataByids: function getdataByids(ids, type, xor) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(_this5.selectedRowKeys.length > 0)) {
                _context3.n = 5;
                break;
              }
              params = {
                condition: {},
                productOpitonIdStr: ids.join(',')
              };
              _this5.btnLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return getProductList(params);
            case 2:
              res = _context3.v;
              if (res.data.code == 200) {
                _this5.selectedData = res.data.data.list;
                _this5.$emit('confirmProduct', _this5.selectedData);
              }
            case 3:
              _context3.p = 3;
              _this5.btnLoading = false;
              _this5.visible = false;
              _this5.resetAll();
              return _context3.f(3);
            case 4:
              _context3.n = 6;
              break;
            case 5:
              _this5.selectedData = [];
              _this5.$emit('confirmProduct', _this5.selectedData);
              _this5.resetAll();
              _this5.visible = false;
            case 6:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    handleOk: function handleOk() {
      this.getdataByids(this.selectedRowKeys);
    },
    handleCancel: function handleCancel() {
      this.resetAll();
      this.visible = false;
    },
    resetAll: function resetAll() {
      var h = this.$createElement;
      this.queryParam = {
        productGrounpd: []
      };
      this.selectedRowKeys = [];
      this.data = [];
      this.pagination.total = 0;
      this.locale = {
        emptyText: h("a-empty", {
          "attrs": {
            "image": Empty.PRESENTED_IMAGE_SIMPLE
          }
        }, [" ", h("span", {
          "slot": "description"
        }, [" ", this.$t('account.emptyGoodsTip'), " "]), "  "])
      };
      this.total = 0;
    }
  }
};